<template>
  <v-app id="driver-app">
    <v-app-bar app color="rgba(84, 88, 90, 0.2)" elevation="2" class="driver-app-bar">
      <!-- Logos -->
      <div class="d-flex align-center logo-container">
        <img 
          src="/img/icons/GiftItForward Logo-02.svg" 
          alt="Gift It Forward Logo" 
          class="app-bar-logo ml-2 mt-2"
        />
        <img 
          src="/img/icons/DH Logo-01.svg" 
          alt="DH Logo" 
          class="app-bar-logo"
        />
      </div>
      
      <v-spacer />
      
      <v-toolbar-title class="font-weight-bold custom-title-color d-none d-sm-flex">
        <v-icon left class="custom-title-color">mdi-truck-delivery</v-icon>
        <span class="d-none d-md-inline">Logistics Driver Interface</span>
        <span class="d-inline d-md-none">Driver</span>
      </v-toolbar-title>
      
      <v-spacer />
      
      <v-btn icon @click="handleLogout" class="custom-title-color">
        <v-icon class="custom-title-color">mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main class="driver-main">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'DriverLayout',

  methods: {
    handleLogout() {
      // Clear driver authentication
      localStorage.removeItem('driver_token');
      localStorage.removeItem('driver_info');
      this.$router.push({ name: 'driver-login' });
    },
  },
};
</script>

<style scoped lang="scss">
#driver-app {
  background-color: rgba(84, 88, 90, 0.2);
}

.driver-app-bar {
  z-index: 10;
}

.custom-title-color {
  color: rgb(16, 24, 32) !important;
}

.logo-container {
  gap: 8px;
}

.app-bar-logo {
  height: 40px;
  width: auto;
  max-width: 120px;
  object-fit: contain;
}

.driver-main {
  background-color: rgba(84, 88, 90, 0.2);
  min-height: calc(100vh - 56px); // viewport - app-bar
}

// Mobile-first optimizations
@media (max-width: 600px) {
  .driver-main {
    padding-bottom: 0 !important;
  }
  
  .app-bar-logo {
    height: 32px;
    max-width: 90px;
  }
}

// Tablet breakpoint
@media (max-width: 960px) {
  .app-bar-logo {
    height: 36px;
    max-width: 100px;
  }
}
</style>

